import { useQuery } from 'react-admin';

function useGetAllCategories() {
    const {data = [], loading, loaded, error} = useQuery(
        {
            type: "all",
            resource: "categories",
            payload: {
                filter: {
                    deleted_at: true,
                },
                sort: [{
                    field: "created_at",
                    order: "DESC",
                },{
                    field: "id",
                    order: "ASC",
                }],
            },
        },
        []
    );
    return {
        data, 
        loading, 
        loaded, 
        error,
    }
}

export default useGetAllCategories;
